import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { DataBlocks, Heading, I18n, Status, Button, FileUpload, Link } from 'components';

import styles from '../../styles.pcss';

const cx = classNames.bind(styles);

const UpdateDataFromPassport = ({
  fileNames, getImgSrc, previewElements, onFileChange, uploadState, files, largeFiles, onUploadSubmit,
}) => (
  <DataBlocks.Container>
    <img
      className={cx('previewImg')}
      src="//static.beeline.ru/upload/images/b2c/selfReg/preview/passport.jpg"
      alt="Паспорт"
    />
    <div className={cx('case')}>
      <Heading level={4} tagName="h5" className={cx('caseHeading')}>
        <I18n path="settings.passportUpload.headingFirstCase" />
      </Heading>
      <I18n className={cx('caseDescription', 'black')} path="settings.passportUpload.descriptionFirstCase" />
      {fileNames.map((name) => (
        <div
          className={cx('fileForm')}
          key={name}
        >
          <div className={cx('filePreview')}>
            <img
              src={getImgSrc(name)}
              ref={(e) => { previewElements[name] = e; }}
              alt=""
            />
          </div>
          {uploadState && (
            <span className={cx('uploadIcon', !files[name] && 'error')}>
              {files[name] ? '✓' : '?'}
            </span>
          )}
          <div>
            <I18n className={cx('uploadTitle')} path={`settings.passportUpload.${name}.title`} />
            <I18n className={cx('uploadText')} path={`settings.passportUpload.${name}.text`} />
            {uploadState !== 'success' && (
              <FileUpload
                className={cx('fileInput')}
                name={name}
                maxSize={10485760}
                accept="image/png, image/jpeg, image/gif, image/tiff, application/pdf"
                onChange={onFileChange(name)}
                previewElement={previewElements[name]}
                defaultSrc={getImgSrc(name)}
                disabled={uploadState === 'loading'}
              >
                <Link className={cx('uploadLink')}>
                  <I18n path="settings.passportUpload.uploadFile" />
                </Link>
              </FileUpload>
            )}
            {largeFiles[name] && (
              <I18n className={cx('errorText')} path="settings.passportUpload.tooLargeError" />
            )}
          </div>
        </div>
      ))}
      {uploadState === 'success' ? (
        <>
          <Status className={[cx('status'), 'success']}>
            <I18n path="settings.passportUpload.postSuccess" />
          </Status>
          <Status className={cx('status')}>
            <I18n path="settings.passportUpload.postDelay" />
          </Status>
        </>
      ) : (
        <Button
          onClick={onUploadSubmit}
          isLoading={uploadState === 'loading'}
        >
          <I18n path="settings.passportUpload.uploadButton" />
        </Button>
      )}
      {uploadState !== 'success' && (
        <I18n className={cx('tip')} path="settings.passportUpload.tip" />
      )}
      {uploadState === 'uploadError' && (!files.passport || !files.registration) && (
        <I18n className={cx('tip', 'error')} path="settings.passportUpload.needMorePhoto" />
      )}
      {uploadState === 'serverError' && (
        <I18n className={cx('tip', 'error')} path="settings.passportUpload.postError" />
      )}
    </div>
  </DataBlocks.Container>
);

UpdateDataFromPassport.propTypes = {
  fileNames: PropTypes.array,
  getImgSrc: PropTypes.func,
  previewElements: PropTypes.object,
  onFileChange: PropTypes.func,
  uploadState: PropTypes.string,
  files: PropTypes.object,
  largeFiles: PropTypes.object,
  onUploadSubmit: PropTypes.func,
};

export default UpdateDataFromPassport;
